export default __webpack_public_path__ + "static/media/hackclub.80622795.png";